import { SHC_ACTIONS } from '../../actions/shcActions';

const shcReducer = (state = {
  chartsLoaded: 0,
  chartsToBeLoaded: 1,
  shcData: null,
  shcEvent: null
}, action) => {
  switch (action.type) {
    case SHC_ACTIONS.FETCH_DATA:
      state = {
        ...state,
        shcData: action.payload,
        shcEvent: 'FETCH_DATA_DONE'
      }
      break;
    case SHC_ACTIONS.CHART_LOADED:
      state = {
        ...state,
        chartsLoaded: state.chartsLoaded + 1,
        shcEvent: 'CHART_LOADED'
      }
      break;
    default:
      break;
  }
  return state;
};

export default shcReducer;
